
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaiairporttopunecab() {



    const cardData =
    {
        keyword: 'Mumbai airport to Pune Cab',
        heading: 'S9 Travels:  Mumbai airport to Pune Cab',
        headingDescription: 'S9 Travels offers dependable and comfortable Mumbai Airport to Pune cab services, perfect for both business and leisure travelers looking for a stress-free airport transfer. Covering a distance of approximately 150 km, the journey takes just 3 to 3.5 hours via expressway, ensuring a quick and smooth ride.',

        top: 'Top Places to Visit in Pune with S9 Travels',

"topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Shaniwar Wada is a historic fortification in Pune, built in 1732. It was the seat of the Peshwas of the Maratha Empire. The fort is known for its majestic architecture, intricate carvings, and historical significance."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Aga Khan Palace is a historic landmark that played a crucial role in India’s freedom struggle. It served as a prison for Mahatma Gandhi and his associates during the Quit India Movement. The palace is now a museum displaying various artifacts related to Gandhi’s life."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Perched atop a hill, Sinhagad Fort is a historic site that offers breathtaking views of the surrounding landscape. It is known for its significance in Maratha history and is a popular trekking destination for adventure enthusiasts."
    },
    {
      "title": "Dagdusheth Halwai Ganpati Temple",
      "description": "This famous temple is dedicated to Lord Ganesha and attracts thousands of devotees every year. Known for its beautiful idol adorned with gold and jewelry, the temple is a must-visit for spiritual seekers and tourists alike."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An ancient rock-cut temple dedicated to Lord Shiva, the Pataleshwar Cave Temple dates back to the 8th century. It is a significant architectural and historical site, offering a serene and spiritual experience."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This fascinating museum houses an extensive collection of artifacts, sculptures, musical instruments, and everyday objects from Indian history. It provides a glimpse into India’s rich cultural heritage."
    },
    {
      "title": "Vetal Tekdi",
      "description": "Vetal Tekdi is a popular hill in Pune known for its scenic beauty and trekking trails. It is an ideal spot for nature lovers and fitness enthusiasts looking for an early morning hike or a peaceful escape from the city."
    },
    {
      "title": "Pashan Lake",
      "description": "Pashan Lake is a tranquil artificial lake that serves as a great spot for birdwatching and leisurely walks. It’s a perfect place to unwind amidst nature and enjoy the peaceful surroundings."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-renowned spiritual retreat offering meditation programs, wellness therapies, and a serene environment for self-discovery."
    },
    {
      "title": "FC Road and JM Road",
      "description": "Fergusson College Road (FC Road) and Jangali Maharaj Road (JM Road) are bustling streets famous for their shopping, street food, and lively ambiance. From trendy clothes to delicious street snacks, these roads are a paradise for youngsters and shopaholics."
    }
],

"services": [
  {
    "name": "Mumbai Airport to Pune Innova Cab",
    "description": "Book a dependable Innova cab from Mumbai Airport to Pune with S9 Travels. Our drivers track your flight for timely pickup, ensuring a safe and smooth transfer even in case of delays."
  },
  {
    "name": "Comfortable Mumbai to Pune Innova Taxi",
    "description": "Need a relaxing ride after landing? Choose our spacious Innova cabs from Mumbai to Pune for comfortable airport transfers, professional drivers, and stress-free journeys."
  },
  {
    "name": "Private Cab from Pune to Mumbai Airport",
    "description": "Whether you're departing or returning, our private Innova cab services offer a quiet and spacious ride from Mumbai airport to Pune Cab and back — ideal for executives and solo travelers."
  },
  {
    "name": "Luxury Innova Crysta from Mumbai Airport to Pune",
    "description": "Travel in style with our luxury Innova Crysta cab service from Mumbai Airport to Pune. Perfect for business class or premium comfort seekers who prefer a first-class ride."
  },
  {
    "name": "Affordable Innova Cab: Pune to Mumbai & Back",
    "description": "Get cost-effective yet comfortable Innova taxi services. Whether heading to Mumbai Airport or returning to Pune, our cabs offer budget-friendly pricing without compromise."
  },
  {
    "name": "Group Airport Transfers in Innova",
    "description": "Travel as a group with our 6- or 7-seater Innova cabs from Mumbai Airport to Pune. Ample luggage space and smooth rides make group transfers easy and convenient."
  },
  {
    "name": "Round Trip Cab: Pune to Mumbai Airport & Return",
    "description": "Book a round-trip Innova from Pune to Mumbai Airport with a guaranteed return pickup. Our Mumbai Airport to Pune cab ensures you're never stranded post-flight."
  }
],

"tableData": [
  ["Mumbai Airport to Pune Innova Cab", "Comfortable Mumbai to Pune Innova Taxi"],
  ["Private Cab from Pune to Mumbai Airport", "Luxury Innova Crysta from Mumbai Airport to Pune"],
  ["Affordable Innova Cab: Pune to Mumbai & Back", "Group Airport Transfers in Innova"],
  ["Group Airport Transfers in Innova", "Round Trip Cab: Pune to Mumbai Airport & Return"],
  
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand how important it is to catch your flight or reach your destination on time. Whether you're arriving at Mumbai Airport or traveling to Pune, we ensure prompt pickups and a smooth journey. Our drivers are punctual and dedicated to getting you to Pune efficiently."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our Toyota Innova is an ideal choice for your ride from Mumbai Airport to Pune. With comfortable seating, air conditioning, and plenty of space for your luggage, you’ll experience a relaxing and stress-free journey. Whether you're traveling solo or with family, our Innova cabs ensure a comfortable trip."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are highly experienced and familiar with the best routes from Mumbai Airport to Pune. They are courteous, punctual, and knowledgeable, ensuring a safe and smooth journey. You can rely on them for a seamless travel experience."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive and transparent pricing for your Mumbai Airport to Pune cab. You’ll receive a clear breakdown of all costs before confirming your booking, with no hidden charges, so you can plan your journey with confidence."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our top priority. Our Toyota Innova vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking. We ensure you enjoy a secure and comfortable ride as you travel from Mumbai Airport to Pune."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "Whether you’re arriving at Mumbai Airport in the early morning or late at night, S9 Travels is available 24/7. We’ll ensure your ride is ready whenever you land, and our customer service team is available to assist you round the clock."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Mumbai Airport to Pune cab is simple and hassle-free with S9 Travels. You can book online via our website or mobile app, or contact our customer service team for personalized assistance in securing your ride."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "If you have specific travel needs or requests, we offer customized travel packages. Whether you need a direct ride to your destination or a stop along the way, we can tailor the trip to meet your requirements."
  }
]











    }



    const faqData = [
        [
          {
            question: 'How can I book a cab from Mumbai Airport to Pune with S9 Travels?',
            answer: 'Booking a cab for your Mumbai Airport to Pune trip is simple! You can book online through our website or mobile app, or contact our customer service team for assistance with your booking.'
          },
          {
            question: 'What types of cabs are available for Mumbai Airport to Pune travel?',
            answer: 'We offer a range of vehicles, including the spacious Toyota Innova, which is ideal for families, groups, or anyone with extra luggage. Choose the vehicle that best fits your needs for a comfortable journey.'
          },
          {
            question: 'Are the drivers experienced for the Mumbai Airport to Pune route?',
            answer: 'Yes, our drivers are highly experienced and familiar with the best routes from Mumbai Airport to Pune, ensuring a smooth, safe, and timely journey.'
          },
          {
            question: 'What payment options are available for booking a cab from Mumbai Airport to Pune?',
            answer: 'We offer multiple payment methods, including cash, credit/debit cards, and secure online payments via our mobile app, providing you with flexible payment options for your convenience.'
          },
          {
            question: 'Can I book a round trip from Mumbai Airport to Pune?',
            answer: 'Yes, we offer round-trip bookings. Simply provide your return details, and we’ll arrange a smooth and comfortable ride back from Pune to Mumbai Airport.'
          },
          {
            question: 'Are there any extra charges for detours or waiting time during the trip?',
            answer: 'Any extra charges for detours or waiting time, if applicable, will be communicated to you clearly before the trip, ensuring full transparency in pricing.'
          },
          {
            question: 'Can I make additional stops on the way from Mumbai Airport to Pune?',
            answer: 'Yes, you can request additional stops. Please inform us during the booking process, and we will accommodate your requests for detours or stops along the way.'
          },
          {
            question: 'What is the luggage allowance for a cab on the Mumbai Airport to Pune trip?',
            answer: 'The Toyota Innova offers ample space for standard luggage. If you have more luggage or specific requirements, please inform us at the time of booking, and we will ensure the necessary arrangements are made.'
          },
          {
            question: 'Does S9 Travels provide corporate travel services for Mumbai Airport to Pune?',
            answer: 'Yes, we provide corporate travel services for business travelers going from Mumbai Airport to Pune. Our professional drivers and comfortable vehicles ensure a hassle-free ride for your business needs.'
          },
          {
            question: 'Why should I choose S9 Travels for my Mumbai Airport to Pune cab booking?',
            answer: 'S9 Travels offers a reliable, comfortable, and safe ride with professional drivers, well-maintained vehicles, and excellent customer service, ensuring a smooth and enjoyable journey from Mumbai Airport to Pune.'
          }
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Sanjay Verma',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I recently booked a ride from Mumbai Airport to Pune with S9 Travels, and it was a great experience. The driver was professional, the car was clean, and the ride was smooth and comfortable. I would highly recommend them for airport transfers!”'
        },
        {
          name: 'Mrs. Anjali Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I used S9 Travels for a ride from Mumbai Airport to Pune, and I was very pleased with the service. The vehicle was spacious, the driver was courteous, and we reached Pune quickly and comfortably. I will definitely use their services again!”'
        }
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
      
      

      
// const productSchema = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "Mumbai Airport to Pune Cab",
//   "image": "https://www.s9travels.com/images/keyword/89.jpg",
//   "description": "Book Mumbai Airport to Pune Cab with S9 Travels for safe, on-time, and affordable airport transfer services. Whether you need a one-way drop, round-trip, or luxury ride, our professional drivers and AC vehicles ensure comfort, punctuality, and reliability on every trip.",
//   "brand": {
//     "@type": "Brand",
//     "name": "S9 Travels"
//   },
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.8",
//     "ratingCount": "11234"
//   },
//   "offers": {
//     "@type": "Offer",
//     "priceCurrency": "INR",
//     "price": "2799",
//     "availability": "https://schema.org/InStock",
//     "url": "https://www.s9travels.com/Mumbai-airport-to-Pune-Cab"
//   }
// };

      
      
     
      const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport to Pune Cab Service – S9 Travels",
  "image": "https://www.s9travels.com/images/keyword/89.jpg",
  "description": "Book Mumbai Airport to Pune Cab with S9 Travels starting at ₹2799. Choose Hatchback, Sedan, SUV & Innova Crysta for one-way airport transfers or round trips. Enjoy professional drivers, clean AC cars, 24/7 customer support, on-time pickup, and instant booking.",
  "brand": {
    "@type": "Brand",
    "name": "S9 Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8457"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2799",
    "availability": "https://schema.org/InStock",
    "url": "https://www.s9travels.com/Mumbai-airport-to-Pune-Cab"
  }
};



      


    return (
        <div>
         
<Helmet>
  <title>Mumbai Airport to Pune Cab from ₹2799 | One-Way & Airport Transfer – S9 Travels</title>
  
  <meta 
    name="description" 
    content="Hire Mumbai Airport to Pune cab with S9 Travels from ₹2799. Get one-way or round-trip airport transfers in Hatchback, Sedan, SUV & Innova Crysta. Safe travel with AC cars, professional drivers, on-time pickup, 24/7 support, and instant online booking." 
  />

  <meta 
    name="keywords" 
    content="Mumbai Airport to Pune Cab, Mumbai Airport to Pune Taxi, One Way Airport Cab Mumbai Pune, Mumbai Airport Drop to Pune, Prepaid Taxi Mumbai Airport to Pune, Luxury Cab Mumbai Pune Airport, Innova Crysta Cab Mumbai Airport to Pune, Online Cab Booking Mumbai Airport Pune, Affordable Airport Transfer Mumbai Pune" 
  />

  <link rel="canonical" href="https://www.s9travels.com/Mumbai-airport-to-Pune-Cab" />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

{/* 
<Helmet>
  <title>Mumbai Airport to Pune Cab | S9 Travels</title>
  <meta 
    name="description" 
    content="Book Mumbai Airport to Pune cab online with S9 Travels. Enjoy one-way, round-trip, or luxury cabs with professional drivers, AC cars, and timely pickup for a safe and smooth airport transfer experience." 
  />
  <meta 
    name="keywords" 
    content="Mumbai Airport to Pune Cab, Cab from Mumbai Airport to Pune, One Way Airport Taxi Mumbai to Pune, Mumbai Airport Pickup to Pune, Luxury Cab Mumbai Airport to Pune, Airport Transfer Mumbai to Pune, S9 Travels Mumbai to Pune Cab" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

// by this showing on 6:10
*/}


      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/89.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaiairporttopunecab;